import store from "../store";
import Constants from "../config/constants";
import { serviceGetTaxFilings } from "../services/TaxFiling.service";
import EventEmitter from "../libs/Events.utils";

export const FETCH_INIT = "FETCH_INIT_TAX_FILING_LIST";
export const FETCHED = "FETCHED_TAX_FILING_LIST";
export const FETCHED_FAIL = "FETCHED_FAIL_TAX_FILING_LIST";
export const FETCHED_FILTER = "FETCHED_FILTER_TAX_FILING_LIST";
// export const NEXT_PREQUESTS = 'NEXT_PREQUESTS';
// export const PREV_PREQUESTS = 'PREV_PREQUESTS';
export const FETCH_NEXT = "FETCH_NEXT_TAX_FILING_LIST";
export const FILTER = "FILTER_TAX_FILING_LIST";
export const RESET_FILTER = "RESET_FILTER_TAX_FILING_LIST";
export const SET_SORTING = "SET_SORTING_TAX_FILING_LIST";
export const SET_FILTER = "SET_FILTER_TAX_FILING_LIST";
export const SET_PAGE = "SET_PAGE_TAX_FILING_LIST";
export const CHANGE_PAGE = "CHANGE_PAGE_TAX_FILING_LIST";
export const CHANGE_STATUS = "CHANGE_STATE_TAX_FILING_LIST";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_TAX_FILING_LIST";
export const CREATE_DATA = "CREATE_TAX_FILING_LIST";
export const UPDATE_DATA = "UPDATE_TAX_FILING_LIST";
export const DELETE_ITEM = "DELETE_TAX_FILING_LIST";

export function actionFetchTaxFilingList(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetTaxFilings({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionChangePageTaxFiling(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterTaxFiling(value) {
  const request = null; ////serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); //dispatch function
    });
  };
}

export function actionChangeStatusTaxFiling(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterTaxFiling() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageTaxFiling(page) {
  const stateData = store.getState().tax_filing;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchTaxFilingList(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
